import React, {useState} from 'react';

const SearchBar = ({ onSubmit }) => {

    const [term,setTerm] = useState('');

    const onFormSubmit = (event) => {
        //Defaultで設定されたリロードを起動させない
        event.preventDefault()
        onSubmit(term);
  

    }
    return (
        <div className='ui segment'>
            <form onSubmit={onFormSubmit} className='ui form'>
                <div className='field'>
                    <label>Image Search</label>
                    <input 
                        type='text' 
                        name='search' 
                        placeholder='' 
                        value={term} 
                        onChange={(event) => {
                            setTerm(event.target.value);
                    }}
                    />
                </div>
            </form> 
        </div>
    );
};

export default SearchBar;